import React from "react";
import { Link } from "react-router-dom";
import { Card, RadioGroup } from "web-ui";
import { LegacyButton as Button } from "web-ui/legacy";

import styles from "../../styles/AudioGenerator/AudioGenerator.module.scss";

import type { AudioGenerationFlags, TargetService } from "./AudioGenerator";
/* eslint-disable react/jsx-no-literals */
export const TargetServiceScreen = ({
  onNext,
}: {
  onNext: (data: Partial<AudioGenerationFlags>) => void;
}) => {
  const [targetService, setTargetService] = React.useState<TargetService>();

  return (
    <>
      <h2>How would you like to generate the audio?</h2>
      <p>
        We have two different ways to generate text to speech at Duolingo and
        each comes with its own benefits/disadvantages. Choose which one best
        matches your use case.{" "}
      </p>
      {/* @ts-expect-error Types don't match somehow */}
      <RadioGroup
        className={styles["card-group"]}
        onChange={event => setTargetService(event.value as TargetService)}
        value={targetService}
      >
        <Card role="radio" value="duolingo-tts">
          <div className={styles["card"]}>
            <h3>Duolingo TTS</h3>
            <ul>
              <li>
                Audio is stored indefinitely and in a way accessible for the
                Learning App
              </li>
              <li>
                Viseme animations generated automatically (if supported for
                voice)
              </li>
              <li>Can only use voices currently used by the Learning App</li>
              <li>Limited SSML support</li>
            </ul>
          </div>
        </Card>
        <Card role="radio" value="tts-generation-backend">
          <div className={styles["card"]}>
            <h3>TTS Generation Backend</h3>
            <ul>
              <li>
                Audio is made available for you to download but not stored
                permanently by the service
              </li>
              <li>
                Can support any voice made by Microsoft, Google, or Amazon
              </li>
              <li>Full SSML support (to the extent the provider supports)</li>
              <li>More control over speed</li>
            </ul>
          </div>
        </Card>
      </RadioGroup>
      <Button
        disabled={targetService === undefined}
        onClick={() => onNext({ targetService })}
        variant="solid"
      >
        Next
      </Button>
      <p>
        <Link to="/generate/history">
          Click here to see previous Duolingo TTS requests from this browser
        </Link>
      </p>
    </>
  );
};
